webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'custom-header': __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */],
    'custom-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */]
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StartNow_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Popup_vue__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  components: {
    'start-now': __WEBPACK_IMPORTED_MODULE_0__StartNow_vue__["a" /* default */],
    'popup': __WEBPACK_IMPORTED_MODULE_1__Popup_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showMobMenu: false,
      showPopup: false
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      if (document.body.getBoundingClientRect().top < 0 && !this.showMobMenu) {
        this.$refs.header.classList.add('fixed-header');
      } else {
        this.$refs.header.classList.remove('fixed-header');
      }
    },
    openModal: function openModal() {
      this.showPopup = true;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartNow_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d77efc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartNow_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23d77efc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartNow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d77efc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartNow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup_vue__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StartNow',
  components: {
    'popup': __WEBPACK_IMPORTED_MODULE_0__Popup_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showPopup: false
    };
  },

  methods: {
    openModal: function openModal() {
      this.showPopup = true;
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1064be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f1064be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1064be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiHttp__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Popup',
  data: function data() {
    return {
      emailSent: false,
      contact: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      },
      errors: {},
      valid: false,
      connectionError: false
    };
  },

  methods: {
    clickOutsidePopup: function clickOutsidePopup(e) {
      if (e.target.id === 'popup-wrapper') this.$emit('close');
    },
    validForm: function validForm() {
      this.errors = {};
      this.valid = false;

      if (!this.contact.company) {
        this.valid = this.errors.company = true;
      }
      if (this.contact.phone && !this.validPhone(this.contact.phone)) {
        this.valid = this.errors.phone = true;
      }
      if (this.contact.email) {
        if (!this.validEmail(this.contact.email)) {
          this.valid = this.errors.invalidEmail = true;
        }
      } else {
        this.valid = this.errors.email = true;
      }

      return this.valid;
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone: function validPhone(phone) {
      var re = /^([+]?\d*)$/;
      return re.test(phone);
    },
    resetData: function resetData() {
      this.contact.name = '';
      this.contact.company = '';
      this.contact.email = '';
      this.contact.phone = '';
      this.contact.message = '';
    },
    sendMessage: function sendMessage() {
      var _this = this;

      console.log(this.validForm());
      if (!this.validForm()) {
        console.log(this.validForm());
        Object(__WEBPACK_IMPORTED_MODULE_0__apiHttp__["a" /* post */])('/send-email', this.contact).then(function () {
          _this.emailSent = true;
          _this.resetData();
        }).catch(function () {
          _this.connectionError = true;
        });
      }
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer'
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Features_BigDataScheme_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Features_Advantages_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Features_WhyTachyon_vue__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Features',
  components: {
    'big-data-scheme': __WEBPACK_IMPORTED_MODULE_0__components_Features_BigDataScheme_vue__["a" /* default */],
    'advantages': __WEBPACK_IMPORTED_MODULE_1__components_Features_Advantages_vue__["a" /* default */],
    'why-tachyon': __WEBPACK_IMPORTED_MODULE_2__components_Features_WhyTachyon_vue__["a" /* default */]
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hotspot_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchemeTooltip_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StartNow_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BigDataScheme',
  data: function data() {
    return {
      window: {
        width: 0
      }
    };
  },

  components: {
    'hotspot': __WEBPACK_IMPORTED_MODULE_0__Hotspot_vue__["a" /* default */],
    'tooltip': __WEBPACK_IMPORTED_MODULE_1__SchemeTooltip_vue__["a" /* default */],
    'start-now': __WEBPACK_IMPORTED_MODULE_2__StartNow_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Hotspot'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SchemeTooltip'
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Advantages',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      advantages: [{
        img: '/static/img/features_page/ai_icon.svg',
        alt: 'ai/machine learning pilot project',
        title: 'Your gateway to a successful AI/Machine Learning pilot project',
        text: '<p>The simplest, quickest and cheapest way to track, collect, clean and democratise your big data.</p>\n                 <p>Tachyon is ideal product to pilot any machine learning project for your business, with the scalability to promote to full production at any time.</p>'
      }, {
        img: '/static/img/features_page/pipeline_icon.svg',
        alt: 'scalable big data pipeline',
        title: 'The Most performant & scalable big data pipeline in the market',
        text: '<p>Your path through a digital transformation doesn\u2019t have to be complex, long and costly one.</p>\n                 <p>Tachyon is a simple, highly scalable, ultra performant big data collection,consolidation and democratisation platform.</p>'
      }]
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WhyTachyon'
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(57);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






if (!('IntersectionObserver' in window)) {
  __webpack_require__(59);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__["VLazyImagePlugin"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dea9b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dea9b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c602c4dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(30);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c602c4dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c602c4dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return post; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var apiURL = 'http://api.tachyondata.com';

var post = function post(path, data) {
  return vue.$http.post('' + apiURL + path, data);
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"popup-wrapper"},on:{"click":_vm.clickOutsidePopup}},[_c('div',{staticClass:"popup-content"},[(!_vm.emailSent)?_c('h3',{staticClass:"blue-text"},[_vm._v("Please tell us your details and we will be in touch with you:")]):_vm._e(),_vm._v(" "),(_vm.emailSent)?_c('h3',{staticClass:"blue-text"},[_vm._v("We got your message.")]):_vm._e(),_vm._v(" "),_c('form',[(!_vm.emailSent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact.name),expression:"contact.name"}],attrs:{"type":"text","name":"name","id":"name"},domProps:{"value":(_vm.contact.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contact, "name", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"company"}},[_vm._v("Company *")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact.company),expression:"contact.company"}],attrs:{"type":"text","name":"company","id":"company"},domProps:{"value":(_vm.contact.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contact, "company", $event.target.value)}}}),_vm._v(" "),(_vm.errors.company)?_c('div',{staticClass:"error"},[_vm._v("Enter Company")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email *")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact.email),expression:"contact.email"}],attrs:{"type":"email","name":"email","id":"email"},domProps:{"value":(_vm.contact.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contact, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.email)?_c('div',{staticClass:"error"},[_vm._v("Enter Email")]):_vm._e(),_vm._v(" "),(_vm.errors.invalidEmail)?_c('div',{staticClass:"error"},[_vm._v("Invalid email address")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Telephone")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact.phone),expression:"contact.phone"}],attrs:{"type":"tel","name":"phone","id":"phone"},domProps:{"value":(_vm.contact.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contact, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.errors.phone)?_c('div',{staticClass:"error"},[_vm._v("Invalid telephone number")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"message"}},[_vm._v("Message")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact.message),expression:"contact.message"}],attrs:{"type":"text","name":"message","id":"message"},domProps:{"value":(_vm.contact.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contact, "message", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.emailSent)?_c('div',{staticClass:"blue-text"},[_c('h3',[_vm._v("Thank you for contacting us!")])]):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('div',{staticClass:"btn-wrapper"},[_c('button',{staticClass:"send-button",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_vm._v("Send")])]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.connectionError)?_c('div',{staticClass:"error-message"},[_c('h3',[_vm._v("Something is wrong. Please check your internet connection and try again.")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"popup-bottom"},[_vm._v("Feel free to get in touch with us on "),_c('br'),_vm._v("+44 (0)20 808 80034")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn-start",attrs:{"type":"button"},on:{"click":_vm.openModal}},[_vm._v("Start Now")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showPopup)?_c('popup',{on:{"close":function($event){_vm.showPopup = false}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{ref:"header",class:{'open-mobile-menu': _vm.showMobMenu}},[_c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":"logo"}})])],1),_vm._v(" "),_c('button',{staticClass:"trigger-menu-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.showMobMenu = !_vm.showMobMenu}}},[(!_vm.showMobMenu)?_c('img',{attrs:{"src":"/static/img/hamburger-menu.png","alt":"menu"}}):_c('img',{attrs:{"src":"/static/img/close.png","alt":"close"}})]),_vm._v(" "),_c('div',{staticClass:"main-menu"},[_vm._m(0),_vm._v(" "),_c('start-now')],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMobMenu),expression:"showMobMenu"}],staticClass:"mobile-menu"},[_vm._m(1),_vm._v(" "),_c('start-now')],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showPopup)?_c('popup',{on:{"close":function($event){_vm.showPopup = false}}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116367e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(33);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-116367e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116367e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"tachyon-container tachyon-footer"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/footer_logo.png","alt":"logo"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"footer-menu"},[_c('ul',[_c('li',[_c('p',[_vm._v("Tachyon is a product owned by Empire Digital Media Ltd (trading as 1Digit)")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"copyright"},[_vm._v("2019 Copyright - Tachyon"),_c('br'),_vm._v("All Rights Reserved")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('custom-header'),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('custom-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Features__ = __webpack_require__(37);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Features',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Features__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.fullPath.indexOf('/#/') !== -1) next(to.fullPath.replace('/#/', '/'));
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec033fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ec033fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec033fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigDataScheme_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7fd637e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigDataScheme_vue__ = __webpack_require__(47);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7fd637e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigDataScheme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7fd637e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigDataScheme_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hotspot_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55576cc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hotspot_vue__ = __webpack_require__(43);
function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55576cc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hotspot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55576cc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hotspot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotspot"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchemeTooltip_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9eee798_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchemeTooltip_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9eee798"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchemeTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9eee798_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchemeTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features-tooltip"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tachyon-container"},[_c('div',{staticClass:"big-data-scheme-wrapper"},[(_vm.window.width > 1199)?_c('v-lazy-image',{staticClass:"big-data-scheme",attrs:{"src":"/static/img/features_page/big_data_scheme.png","src-placeholder":"/static/img/placeholder.jpg","alt":"big data scheme"}}):_vm._e(),_vm._v(" "),(_vm.window.width > 991 && _vm.window.width < 1200)?_c('v-lazy-image',{staticClass:"big-data-scheme",attrs:{"src":"/static/img/features_page/big_data_scheme_1200.png","src-placeholder":"/static/img/placeholder.jpg","alt":"big data scheme"}}):_vm._e(),_vm._v(" "),(_vm.window.width > 575 && _vm.window.width < 992)?_c('v-lazy-image',{staticClass:"big-data-scheme",attrs:{"src":"/static/img/features_page/big_data_scheme_575.png","src-placeholder":"/static/img/placeholder.jpg","alt":"big data scheme"}}):_vm._e(),_vm._v(" "),(_vm.window.width < 576)?_c('v-lazy-image',{staticClass:"big-data-scheme",attrs:{"src":"/static/img/features_page/big_data_scheme_320.png","src-placeholder":"/static/img/placeholder.jpg","alt":"big data scheme"}}):_vm._e(),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"mobile-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"collect-tooltip mobile-tooltip"},[_vm._v("Mobile Tracking")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"iot-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"collect-tooltip iot-tooltip"},[_vm._v("IOT Connectors")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"tracking-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"collect-tooltip tracking-tooltip"},[_vm._v("Tracking and"),_c('br'),_vm._v("Digital Analytics")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"any-format-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"collect-tooltip any-format-tooltip"},[_vm._v("Any Format Batch"),_c('br'),_vm._v("Data Ingestions")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"sensitize-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"white-tooltip sensitize-tooltip"},[_vm._v("Sensitize All Data For"),_c('br'),_vm._v("Single Source of Truth")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"scheme-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"white-tooltip scheme-tooltip"},[_vm._v("Scheme Creation And Control"),_c('br'),_vm._v("PI Detection BOT Detection"),_c('br'),_vm._v("Business Rules")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"data-lake-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"yellow-tooltip data-lake-tooltip"},[_vm._v("Data Lake Comprising of RAW,"),_c('br'),_vm._v("Transformed and Modified")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"enrich-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"white-tooltip enrich-tooltip"},[_vm._v("Enrich Your Data Create"),_c('br'),_vm._v("Identities Manage Audiences"),_c('br'),_vm._v("Secure Vault For PI")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"consumer-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"white-tooltip consumer-tooltip"},[_vm._v("Single Consumer, View All,"),_c('br'),_vm._v("Touchpoints, Create Device ID,"),_c('br'),_vm._v("Attribution Module, Churn Model")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"api-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"green-tooltip api-tooltip"},[_vm._v("API and"),_c('br'),_vm._v("Generation Layer")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"activate optimization-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"blue-tooltip optimization-tooltip"},[_vm._v("Product Optimization Trough"),_c('br'),_vm._v("Personal Experiences")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"activate marketing-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"blue-tooltip marketing-tooltip"},[_vm._v("Marketing Orchestration"),_c('br'),_vm._v("Including Social Integration")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"activate reporting-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"blue-tooltip reporting-tooltip"},[_vm._v("Any Reporting, Dashboarding"),_c('br'),_vm._v("and analytical tools - Tables,"),_c('br'),_vm._v("Locker, Power")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"activate campaign-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"blue-tooltip campaign-tooltip"},[_vm._v("Campaign Management"),_c('br'),_vm._v("Integrated to Any of your"),_c('br'),_vm._v("Favorite ESP on the Market")])],1),_vm._v(" "),_c('div',[_c('hotspot',{staticClass:"activate decentralization-hotspot"}),_vm._v(" "),_c('tooltip',{staticClass:"blue-tooltip decentralization-tooltip"},[_vm._v("Data Decentralization")])],1)],1),_vm._v(" "),_c('start-now',{staticClass:"start-now"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advantages_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a43a890_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advantages_vue__ = __webpack_require__(51);
function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a43a890"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advantages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a43a890_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advantages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tachyon-container"},[_c('div',{staticClass:"advantages-section"},[_vm._l((_vm.advantages),function(advantage,index){return _c('div',{key:index,staticClass:"advantages-wrapper"},[_c('div',{staticClass:"advantages-block"},[_c('v-lazy-image',{attrs:{"src":advantage.img,"src-placeholder":"/static/img/placeholder.jpg","alt":advantage.alt}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(advantage.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(advantage.text)}})],1),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('carousel',{staticClass:"tachyon-carousel",attrs:{"perPage":1,"navigationClickTargetSize":12,"navigationNextLabel":"","navigationPrevLabel":"","minSwipeDistance":30,"paginationColor":"#bed2e9","paginationActiveColor":"transparent"}},_vm._l((_vm.advantages),function(advantage,index){return _c('slide',{key:index},[_c('div',{staticClass:"slider-title"},[_c('v-lazy-image',{attrs:{"src":advantage.img,"src-placeholder":"/static/img/placeholder.jpg","alt":advantage.alt}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(advantage.title))])],1),_vm._v(" "),_c('div',{staticClass:"slider-text",domProps:{"innerHTML":_vm._s(advantage.text)}})])}),1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WhyTachyon_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd095658_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WhyTachyon_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd095658"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WhyTachyon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd095658_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WhyTachyon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"tachyon-container why-tachyon-section"},[_c('h2',[_vm._v("Why Tachyon?")]),_vm._v(" "),_c('div',{staticClass:"why-tachyon-icons"},[_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/GDPR.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"GDPR"}}),_vm._v(" "),_c('div',[_vm._v("Fully GDPR Compliant (Value)")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/implementation.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"implementation"}}),_vm._v(" "),_c('div',[_vm._v("Implement Single Customer View in Weeks")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/analytics.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"analytics"}}),_vm._v(" "),_c('div',[_vm._v("Real-time Decisioning and Analytics")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/democratization.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"democratization"}}),_vm._v(" "),_c('div',[_vm._v("Democratization of Data")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/time.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"time"}}),_vm._v(" "),_c('div',[_vm._v("Minimal Development Time for ETL Processes and Tasks")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/fingerprint.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"fingerprint"}}),_vm._v(" "),_c('div',[_vm._v("Customer Fingerprinting Out of The Box")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/truth.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"truth"}}),_vm._v(" "),_c('div',[_vm._v("Single Source of Truth")])],1)]),_vm._v(" "),_c('div',[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/why_tachyon_icons/internet-grid.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"internet grid"}}),_vm._v(" "),_c('div',[_vm._v("Integrate With Web, IoT and Any Device With access to The Internet")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"tachyon-container"},[_c('div',{staticClass:"blue-section"},[_c('div',{staticClass:"top-block"},[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/nutshell.png","src-placeholder":"/static/img/placeholder.jpg","alt":"nutshell"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Your path through a digital transformation doesn’t have to be complex, long and costly one.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("To harness the power of big data, you would require an infrastructure that can manage and process huge volumes of structured and unstructured data in realtime and can protect data privacy and security.")])],1),_vm._v(" "),_c('v-lazy-image',{staticClass:"nutshell-img",attrs:{"src":"/static/img/features_page/big_data_visualization.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"big data visualization"}})],1),_vm._v(" "),_c('div',{staticClass:"separation-line1"}),_vm._v(" "),_c('div',{staticClass:"middle-block"},[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/warehouse.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"warehouse"}}),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_c('div',{staticClass:"separation-line2"}),_vm._v(" "),_c('div',{staticClass:"bottom-block"},[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/crm.svg","src-placeholder":"/static/img/placeholder.jpg","alt":"crm"}}),_vm._v(" "),_c('h2',[_vm._v("Activation Systems Integrations such as Marketing Automation and CRM")]),_vm._v(" "),_vm._m(3)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("Tachyon in a"),_c('br'),_vm._v("Nutshell")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Tachyon is a simple, highly scalable, ultra performant big data collection, consolidation and democratisation platform.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('h2',[_vm._v("Tachyon is a friend of BI Developers, Analysts and Data Scientists")]),_vm._v(" "),_c('p',[_vm._v("This include systems like MongoDB that provide operational capabilities for real-time, interactive workloads where data is primarily captured and stored.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("NoSQL Big Data")]),_vm._v(" systems are designed to take advantage of new cloud computing architectures that have emerged over the past decade to allow massive computations to be run inexpensively and efficiently. This makes operational big data workloads much easier to manage, cheaper, and faster to implement.")]),_vm._v(" "),_c('p',[_vm._v("Some NoSQL systems can provide insights into patterns and trends based on real-time data with minimal coding and without the need for data scientists and additional infrastructure.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("These includes systems like Massively Parallel Processing (MPP) database systems and "),_c('span',{staticClass:"blue-text"},[_vm._v("MapReduce")]),_vm._v(" that provide analytical capabilities for retrospective and complex analysis that may touch most or all of the data.")]),_vm._v(" "),_c('p',[_vm._v("These two classes of technology are complementary and frequently deployed together.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features"},[_c('section',{staticClass:"use-tachyon"},[_vm._m(0),_vm._v(" "),_c('big-data-scheme'),_vm._v(" "),_c('div',{staticClass:"tachyon-container section-logos"},[_c('div',{staticClass:"block-logos"},[_c('div',{staticClass:"snowflake-logo"},[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/snowflake.png","src-placeholder":"/static/img/placeholder.jpg","alt":"snowflake"}})],1),_vm._v(" "),_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/ab_eau.png","src-placeholder":"/static/img/placeholder.jpg","alt":"ab eau"}})],1),_vm._v(" "),_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/looker.png","src-placeholder":"/static/img/placeholder.jpg","alt":"looker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"block-logos"},[_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/power_bi.png","src-placeholder":"/static/img/placeholder.jpg","alt":"power bi"}})],1),_vm._v(" "),_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/google_big_query.png","src-placeholder":"/static/img/placeholder.jpg","alt":"google big query"}})],1),_vm._v(" "),_c('div',[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/amazon_s3.png","src-placeholder":"/static/img/placeholder.jpg","alt":"amazon s3"}})],1),_vm._v(" "),_c('div',{staticClass:"data-logo"},[_c('v-lazy-image',{attrs:{"src":"/static/img/features_page/345345.png","src-placeholder":"/static/img/placeholder.jpg","alt":"logo"}})],1)])]),_vm._v(" "),_c('advantages')],1),_vm._v(" "),_c('why-tachyon'),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tachyon-container use-tachyon-title"},[_c('h1',[_vm._v("Use Tachyon "),_c('span',[_vm._v("To Power Your Digital Platform")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bottom-section"},[_c('div',{staticClass:"tachyon-container contact-us-section"},[_c('div',{staticClass:"contact-us"},[_c('h3',{staticClass:"blue-text"},[_vm._v("Get in touch, Experience the power of Tachyon for yourself")]),_vm._v(" "),_c('div',{staticClass:"info",attrs:{"itemscope":"","itemtype":"http://schema.org/PostalAddress"}},[_c('div',{staticClass:"tel",attrs:{"itemprop":"telephone"}},[_vm._v("+44 (0)20 808 80034")]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"mailto:tachyon@1digit.co.uk","itemprop":"email"}},[_vm._v("tachyon@1digit.co.uk")])]),_vm._v(" "),_c('div',[_c('address',{staticClass:"address",attrs:{"itemprop":"address"}},[_vm._v("Kemp House, City Road, London, EC1V 2NX")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.168f8209cd6d73f40f96.js